if (!customElements.get('lsg-steps-list')) {
  class LsgStepsList extends HTMLElement {
    constructor() {
      super();
      this.observer = null;
      this.pinRevealTimers = [];
      this.pinStaggerGen = 0;
    }

    connectedCallback() {
      this.teardown();
      this.setupViewportStagger();
    }

    disconnectedCallback() {
      this.teardown();
    }

    clearPinStagger() {
      this.pinRevealTimers.forEach((id) => window.clearTimeout(id));
      this.pinRevealTimers = [];
      this.pinStaggerGen += 1;
    }

    teardown() {
      this.clearPinStagger();
      this.observer?.disconnect();
      this.observer = null;
    }

    resetStepsHidden() {
      this.querySelectorAll('.lsg-steps__step').forEach((step) => {
        step.classList.remove('lsg-steps__step--in', 'lsg-steps__step--segment-done');
      });
    }

    /**
     * step0 → line after 0 → step1 → line after 1 → … → last step.
     */
    startPinStagger(steps, beatMs = 320) {
      this.clearPinStagger();
      const n = steps.length;
      if (n === 0) return;

      const gen = this.pinStaggerGen;
      const run = (fn) => {
        if (gen !== this.pinStaggerGen) return;
        fn();
      };

      const schedule = (delayMs, fn) => {
        const id = window.setTimeout(() => run(fn), delayMs);
        this.pinRevealTimers.push(id);
      };

      let t = 0;
      for (let i = 0; i < n; i += 1) {
        const si = i;
        schedule(t, () => {
          steps[si].classList.add('lsg-steps__step--in');
        });
        t += beatMs;

        if (i < n - 1) {
          const li = i;
          schedule(t, () => {
            steps[li].classList.add('lsg-steps__step--segment-done');
          });
          t += beatMs;
        }
      }
    }

    setupViewportStagger() {
      const reduceMotion =
        typeof window.matchMedia === 'function' &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const steps = this.querySelectorAll('.lsg-steps__step');

      if (reduceMotion) {
        steps.forEach((step) => {
          step.classList.add('lsg-steps__step--in', 'lsg-steps__step--segment-done');
        });
        return;
      }

      if (typeof IntersectionObserver !== 'function') {
        this.startPinStagger(steps, 320);
        return;
      }

      const beatMs = 320;

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const listSteps = this.querySelectorAll('.lsg-steps__step');
            if (entry.isIntersecting) {
              this.clearPinStagger();
              this.startPinStagger(listSteps, beatMs);
            } else {
              this.clearPinStagger();
              listSteps.forEach((step) => {
                step.classList.remove('lsg-steps__step--in', 'lsg-steps__step--segment-done');
              });
            }
          });
        },
        { root: null, threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
      );

      this.observer.observe(this);
    }
  }

  customElements.define('lsg-steps-list', LsgStepsList);
}